<template>
  <swiper
    class="screen-three-swiper"
    :options="swiperOption"
  >
    <swiper-slide class="screen-one-swiper-item">
      <div class="swiper-slide-content">
        <div class="title">
          <div class="title__zh">成功案例</div>
          <div class="title__en">SUCCESSFUL CASE</div>
          <div class="title__line"></div>
        </div>
        <div class="content">
          <img
            src="@/assets/img_yunda@2x.png"
            class="right_img"
          />
          <div class="content-right">
            <div class="content-right-word">
              韵达充电站由思极星能科技(四川)有限公司运营，场站占地13亩，有20台120KW直流充电桩，
              40把快充枪，同时配备110㎡顾客服务区，方便客户在车辆充
              电时休息等待。
            </div>
            <div class="content-icons-item">
              <div class="flex_cc item">
                <img
                  src="@/assets/icon_rijuncheci@2x.png"
                  class="icons_img"
                />
                <div>日均车次</div>
              </div>
              <div class="flex_cc item num">
                <div class="car">
                  <span class="car-word">49</span>
                  <span>车次</span>
                </div>
                <div class="date">2019年6月</div>
              </div>
              <div class="flex_cc item">
                <img
                  class="icon_arrow"
                  src="@/assets/icon_arrow@2x.png"
                />
              </div>
              <div class="flex_cc item num">
                <div class="car">
                  <span class="car-word">550</span>
                  <span>车次</span>
                </div>
                <div class="date">2022年8月</div>
              </div>
            </div>
            <div class="content-icons-item">
              <div class="flex_cc item">
                <img
                  src="@/assets/icon_rijunxiaoliang@2x.png"
                  class="icons_img"
                />
                <div>日均销量</div>
              </div>
              <div class="flex_cc item num">
                <div class="car">
                  <span class="car-word">1715</span>
                  <span>度</span>
                </div>
                <div class="date">2019年6月</div>
              </div>
              <div class="flex_cc item">
                <img
                  src="@/assets/icon_arrow@2x.png"
                  class="icon_arrow"
                />
              </div>
              <div class="flex_cc item num">
                <div class="car">
                  <span class="car-word">15000</span>
                  <span>度</span>
                </div>
                <div class="date">2022年8月</div>
              </div>
            </div>
          </div>
        </div>
        <Button
          class="know-more"
          @click="toCase"
        >了解更多</Button>
      </div>
    </swiper-slide>

    <div
      class="swiper-pagination swiper-pagination-white"
      slot="pagination"
    ></div>
  </swiper>
</template>

<script>
import Button from "@/components/button";

export default {
  components: {
    Button
  },

  data() {
    return {
      swiperOption: {
        touchRatio: 0.8,
        speed: 800,
        parallax: true
        // pagination: {
        //   el: ".swiper-pagination",
        //   clickable: true,
        //   renderBullet: (index, className) => {
        //     return `<div class="${className} full-swiper-pagination-custom-line"></div>`;
        //   }
        // }
      }
    };
  },

  methods: {
    toCase() {
      this.$router.push("/case");
    }
  }
};
</script>

<style lang="less">
  @media screen and (min-width: 481px) {
    .screen-three-swiper {
  color: @white;
  height: 100%;

  &-item {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .swiper-slide-content {
    position: relative;
    display: flex;
    flex-direction: column;
    width: 894px;
    height: 590px;

    .title {
      padding-top: 60px;
      margin: 0 auto;
      text-align: center;
      display: flex;
      flex-direction: column;
      align-items: center;
      &__zh {
        font-size: 36px;
        color: @white;
      }
      &__en {
        color: @text-primary;
        text-transform: uppercase;
      }
      &__line {
        margin-top: 8px;
        width: 30px;
        height: 3px;
        background: linear-gradient(
          90deg,
          rgba(9, 154, 255, 1) 0%,
          rgba(58, 254, 254, 1) 100%
        );
        border-radius: 10em;
      }
    }
    .content {
      width: 100%;
      margin-top: 30px;
      display: flex;
      justify-content: flex-start;
      align-items: center;

      .right_img {
        width: 500px;
        max-width: 50%;
        box-shadow: 20px 20px 0 0 #012762;
      }
      &-right {
        margin-left: 70px;
        font-size: 14px;
        color: rgba(214, 226, 255, 1);
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        &-word {
          text-indent: 2em;
          line-height: 2.5;
        }
      }

      &-icons-item {
        color: #7b9aeb;
        font-size: 16px;
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
      .icons_img {
        width: 50px;
        height: 50px;
      }
      .flex_cc {
        height: 80px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-direction: column;
        white-space: nowrap;
        .car {
          color: #58e0ff;
          white-space: nowrap;
          &-word {
            font-size: 35px;
            font-weight: bold;
          }
        }
        .date {
          font-size: 14px;
        }
      }

      .item {
        flex: 1;
        justify-content: center;
        &.num {
          min-width: 140px;
        }
      }
      .icon_arrow {
        width: 27px;
        height: 21px;
      }
    }
    .know-more {
      margin: 60px auto 0;
    }
  }
}
  }
  @media screen and (max-width: 480px) {
    .screen-three-swiper {
  color: @white;
  height: 100%;

  &-item {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .swiper-slide-content {
    position: relative;
    display: flex;
    flex-direction: column;
    width: 894px;
    height: 590px;

    .title {
      padding-top: 60px;
      margin: 0 auto;
      text-align: center;
      display: flex;
      flex-direction: column;
      align-items: center;
      &__zh {
        font-size: 36px;
        color: @white;
      }
      &__en {
        color: @text-primary;
        text-transform: uppercase;
      }
      &__line {
        margin-top: 8px;
        width: 30px;
        height: 3px;
        background: linear-gradient(
          90deg,
          rgba(9, 154, 255, 1) 0%,
          rgba(58, 254, 254, 1) 100%
        );
        border-radius: 10em;
      }
    }
    .content {
      width: 100%;
      margin-top: 30px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-flow: column;
      .right_img {
        width: 275px;
        height: 192.5px;
      }
      &-right {
        width: 275px;
        margin-top: 20px;
        font-size: 14px;
        color: rgba(214, 226, 255, 1);
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        &-word {
          text-indent: 2em;
          line-height: 2;
        }
      }

      &-icons-item {
        color: #7b9aeb;
        font-size: 16px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        display: none;
      }
      .icons_img {
        width: 50px;
        height: 50px;
      }
      .flex_cc {
        height: 80px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-direction: column;
        white-space: nowrap;
        .car {
          color: #58e0ff;
          white-space: nowrap;
          &-word {
            font-size: 35px;
            font-weight: bold;
          }
        }
        .date {
          font-size: 14px;
        }
      }

      .item {
        flex: 1;
        justify-content: center;
        &.num {
          min-width: 140px;
        }
      }
      .icon_arrow {
        width: 27px;
        height: 21px;
      }
    }
    .know-more {
      margin: 60px auto 0;
    }
  }
}
  }
</style>